import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingColorPickerFromImageConfig } from '@/data/landingConfig/landingColorPickerFromImageConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ColorPickerFromImage } from './schemaObject';

interface Props {}
const ColorPickerFromImage: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ColorPickerFromImage} />
			<LandingTemplate
				data={landingColorPickerFromImageConfig}
				funnelLinkService={GenerateLandingLinkService.funnelColorPicker()}
			/>
		</>
	);
};

export default ColorPickerFromImage;
